<!--做题新页面-->
<template>
  <div class="content">
    <div class="question" v-if="GetquestionDesc">
      <div class="text">{{ GetquestionDesc }}</div>
    </div>
    <div class="question_choose">
      <div class="choose_danger">
        *以下选项老师根据学生实际情况选择，选项可多选和不选
      </div>
      <div class="questionLists">
        <div
          class="questionList"
          v-for="(item, index) in questions"
          :key="index"
        >
          <span>{{ index + 1 }}.{{ item.Ex_Questions }}</span>
          <div
            v-for="(cc, nn) in item.Ex_AnswerList"
            :key="nn"
            style="font-size: 16px; color: #666"
          >
            {{ cc.Option }}
          </div>
          <div class="rate" v-if="!dateInfo.IsBaby">
            <el-rate
              v-model="item.value"
              :max="6"
              @change="onRateChange($event, index, item)"
            ></el-rate>
          </div>
          <div class="" v-else>
            <el-radio-group v-model="item.value">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
    <el-button type="primary" size="mini" @click="AdminSaveBatchTermInfo"
      >提交评价</el-button
    >
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :show-close="false"
      width="25%"
    >
      <div>
        <div class="mask_title">提交成功!</div>
        <div class="lable_desc">
          评价报告请在评价数据管理班级管理个人页面查看
        </div>
      </div>
      <div @click="onSubmit" class="submit_btn">好的</div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import {
  FrontGetQuestionByCategory,
  AdminSaveBatchTermInfo,
} from "../../api/api";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      dialogVisible: false,
      questionDesc: "", //问题描述
      questions: [],
      iskai: false,
      dateInfo: {},
    };
  },
  //监听属性 类似于data概念
  computed: {
    GetquestionDesc() {
      if (this.questionDesc) {
        return this.questionDesc
          .replace(/&nbsp;/gi, "")
          .replace(/<[^>]+>/gi, "");
      } else {
        return "";
      }
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onRateChange(e, index) {
      this.questions[index].value = e;
    },
    onSubmit() {
      this.dialogVisible = false;
      this.$router.back();
    },

    //提交
    async AdminSaveBatchTermInfo() {
      let contentArr = [];
      this.questions.forEach((item) => {
        contentArr.push({
          id: item.Id,
          value: item.value,
        });
      });
      if (this.iskai) {
        return;
      }
      this.iskai = true;
      let xhr = await AdminSaveBatchTermInfo({
        gradeId: this.dateInfo.gradeId,
        classId: this.dateInfo.classId,
        cateId: this.dateInfo.cateId,
        studentId: this.dateInfo.studentId,
        cycleId: this.dateInfo.cycleId,
        content: contentArr,
        studentIds: this.dateInfo.studentIds,
      });
      this.iskai = false;
      if (xhr.data.success) {
        this.dialogVisible = true;
      } else {
        this.$message.error(xhr.data.msg);
      }
    },

    // 获取题目
    async FrontGetQuestionByCategory() {
      let xhr = await FrontGetQuestionByCategory({
        SId: this.dateInfo.SId,
        IsBaby: this.dateInfo.IsBaby,
        BabyLevel: this.dateInfo.BabyLevel,
      });
      if (xhr.data.success) {
        //console.log(this.$route.query.IsBaby == "false");
        xhr.data.response.forEach((item) => {
          if (this.dateInfo.IsBaby) {
            item.value = 1;
          } else {
            item.value = 0;
          }
        });
        this.questions = xhr.data.response;
      } else {
        this.$message.warning(xhr.data.msg);
      }
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.dateInfo = JSON.parse(unescape(this.$route.query.dateInfo));
    //console.log(this.dateInfo);
    this.questionDesc = this.dateInfo.detail;
  },
  beforeMount() {}, //生命周期 - 挂载之前
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.FrontGetQuestionByCategory();
  },
};
</script>
<style scoped lang="less">
.el-rate {
  height: 50px;
  padding: 10px 0 10px 0;
}
/deep/ .el-rate__icon {
  font-size: 35px;
}
.content {
  padding: 0 20px;
  background: #ffffff;
  padding-top: 10px;
  padding-bottom: 100px;
  .question {
    background: #f2f5ff;
    border-radius: 30px;
    .text {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 36px;
      /* display: flex; */
      padding: 26px 7px 36px 15px;
    }
  }

  .question_choose {
    padding: 21px 0 49px 37px;
    margin-top: 12px;
    .choose_danger {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #f44f4f;
      line-height: 36px;
    }
    .questionLists {
      span {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 36px;
        margin-bottom: 10px;
      }
      .checkBoxIndex {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        cursor: pointer;
      }
      .cricleBox {
        width: 13px;
        height: 13px;
        border: 2px solid #999999;
        border-radius: 50%;
      }
      .cricleBoxActive {
        background: #4cbff4;
        border: 2px solid #4cbff4;
      }
      .Question {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 36px;
        padding-left: 15px;
      }
      .RadioBox {
        cursor: pointer;
      }
      .RadioBox_flex {
        display: flex;
        align-items: center;
      }
      .question_text {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 36px;
        padding-left: 32px;
      }
    }
    .sumbit {
      width: 360px;
      height: 40px;
      background: #4cbff4;
      border-radius: 5px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      margin: 0 auto;
      margin-top: 80px;
      cursor: pointer;
    }
  }
  /deep/.el-dialog {
    border-radius: 30px;
    padding: 0 60px;
    .mask_title {
      font-size: 24px;
      font-family: PingFang SC;
      color: #333333;
      text-align: center;
    }
    .lable_desc {
      margin-top: 30px;
      text-align: center;
    }
    .submit_btn {
      width: 115px;
      height: 40px;
      background: #4cbff4;
      border-radius: 5px;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      margin: 0 auto;
      margin-top: 60px;
      cursor: pointer;
    }
  }
}
</style>